<template>
  <div>
    <el-form inline>
      <el-form-item v-if="company" label="經銷商">
        <selectCompany :id.sync="condition.company_id" />
      </el-form-item>

      <el-form-item v-if="client" label="">
        <selectClient :client-id.sync="condition.client_id" :company-id="condition.company_id" />
      </el-form-item>

      <el-form-item v-if="user" label="">
        <selectUser :user-id.sync="condition.user_id" :company-id="condition.company_id" />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import selectCompany from '@/components/select/companies.vue';
import selectClient from '@/components/select/client.vue';
import selectUser from '@/components/select/user.vue';
export default {
  components: { selectCompany, selectClient, selectUser },
  props: {
    company: {
      default: true,
    },
    client: {
      default: true,
    },
    user: {
      default: true,
    },
  },
  data() {
    return {
      condition: {
        company_id: 1,
        client_id: null,
        user_id: null,
      },
    };
  },
  watch: {
    condition: {
      handler: function () {
        this.$emit('onSearch', this.condition);
      },
      deep: true,
    },
  },
  created() {
    this.$emit('onSearch', this.condition);
  },
};
</script>
